import styled from 'styled-components';

const Wrapper = styled.div`
    padding: 0px 3rem;
    .ant-tabs-ink-bar {
        height: 6px;
        background-color: #ffffff;
    }
    .ant-tabs {
        color: #A8A8B1;
    }
    .ant-tabs-nav .ant-tabs-tab {
        font-size: 15px;
        font-weight: bold;
    }
    .ant-tabs-nav .ant-tabs-tab-active {
        color: #ffffff
    }
    .ant-tabs-nav .ant-tabs-tab:hover {
        color: #ffffff;
    }
    .ant-tabs-bar {
        border-bottom: none;
    }
    .ant-tabs-ink-bar {
        top: 0px;
    }
    @media (max-width: 550px) {
        .ant-tabs-tab-prev-icon, .ant-tabs-tab-next-icon {
            color: #ffffff;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
            color: #ffffff;
            background: #000000;
            border-color: #000000;
            border-bottom: 1px solid #000000;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
            background: #000000;
            border: 1px solid #000000;
        }
    }
    @media (max-width: 960px) {
        padding: 0 12px;
    }
`;

export default Wrapper;
